// extracted by mini-css-extract-plugin
module.exports = {"faq-card":"FaqMainpage_faq-card__1ryLq"};